var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.047,
    height: 26.028,
    viewBox: "0 0 26.047 26.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .userIconA {\n                fill: #fff;\n            }\n\n            .userIconB {\n                fill: #35393b;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1011.499 -9.19)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "userIconA",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1011.499 9.218)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(998.206 -5.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.34 14.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "userIconB",
    d: "M26.34,14.34a13,13,0,1,0,13,13A13.015,13.015,0,0,0,26.34,14.34Zm0,24.906a11.851,11.851,0,0,1-7.581-2.732,5.949,5.949,0,0,1,5.563-3.924h4A5.958,5.958,0,0,1,33.9,36.533,11.851,11.851,0,0,1,26.34,39.246Zm8.422-3.5A7.059,7.059,0,0,0,28.32,31.5h-4a7.049,7.049,0,0,0-6.424,4.23,11.906,11.906,0,1,1,16.864.02Z",
    transform: "translate(-13.34 -14.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "userIconB",
    d: "M39.963,31.7a5.184,5.184,0,1,0,5.184,5.184A5.19,5.19,0,0,0,39.963,31.7Zm0,9.275a4.091,4.091,0,1,1,4.091-4.091A4.1,4.1,0,0,1,39.963,40.972Z",
    transform: "translate(-26.963 -25.369)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.7bd6ab89.svg";
export { ForwardRef as ReactComponent };